import React from 'react'
import SerTab from './SerTab/SerTab'

const Services = () => {
  return (
    <div id="services" className="my-12 bg-gray-100 text-base  text-2xl lg:text-3xl mb-4 ">
        <h2 className='text-3xl my-2'>
            Services
        </h2>
        <div className="grid  grid-cols-1 lg:grid-cols-4 grid-rows-5 gap-10 ">
          <SerTab name="Shoe Gift Customization" link="/services/gifting" height ="h-216" backgroundImage={`https://res.cloudinary.com/custoshoe/image/upload/v1693513969/q1nop0nd0f6usa1zhxt0.jpg`}/>
          <SerTab name="Shoe Customization" link="/services/customization" backgroundImage={`https://res.cloudinary.com/custoshoe/image/upload/v1693513969/si25fvtwmkij9ip1q02d.jpg`}/>
          <SerTab name="Shoe Restoration" link="/services/restoration" backgroundImage={`https://res.cloudinary.com/custoshoe/image/upload/v1693513970/gwlnkp1agc3ecnrzgov8.jpg`}/>
          <SerTab name="Bridal Customization" link="/services/bridal" backgroundImage={`https://res.cloudinary.com/custoshoe/image/upload/v1693513969/lg04qmumiulg8fskglsl.jpg`}/>
        </div>
    </div>
  )
}

export default Services